<template>
    <div class="agency-view">
        <heading :title="title" tag="agency-view-title">
            <b-button v-if="canEdit"
                      variant="primary"
                      :to="`/agency/edit/${agencyId}`">
                Edit Agency
                <b-icon-pencil-square/>
            </b-button>
            <b-button class="ml-4"
                      variant="primary"
                      :to="`/user/list/agency/${agencyId}`">
                List Agency Users
                <b-icon-people-fill/>
            </b-button>
        </heading>
        <b-row>
            <b-col class="col-12 col-md-6 offset-md-3 pt-lg-5">
                <view-table
                    :model="agencyFields"
                    :data="agencyInfo"
                    :fields="showFields">
                    <template v-slot:progAdminUsers="slotProps">
                        <template v-if="slotProps.value && slotProps.value.length">
                            <div v-for="(user,i) in slotProps.value" :key="i">
                                {{ user.full_name }}
                            </div>
                        </template>
                        <template v-else>&nbsp;</template>
                    </template>
                    <template v-slot:ownerRepUsers="slotProps">
                        <template v-if="slotProps.value && slotProps.value.length">
                            <div v-for="(user,i) in slotProps.value" :key="i">
                                {{ user.full_name }}
                            </div>
                        </template>
                        <template v-else>&nbsp;</template>
                    </template>
                    <template v-slot:projectManagerUsers="slotProps">
                        <template v-if="slotProps.value && slotProps.value.length">
                            <div v-for="(user,i) in slotProps.value" :key="i">
                                {{ user.full_name }}
                            </div>
                        </template>
                        <template v-else>&nbsp;</template>
                    </template>
                </view-table>
            </b-col>
        </b-row>
        <b-row class="mx-1 my-4">
            <b-button v-if="canDelete"
                      class="ml-4"
                      variant="danger"
                      @click="deleteAgency()">
                Delete Agency
                <b-icon-trash/>
            </b-button>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import AgencyFields from '@/models/Agency'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'AgencyView',
    props: {
        agencyId: Number,
    },
    data () {
        return {
            title: '',
            agencyInfo: {},
            agencyFields: AgencyFields,
            showFields: ['name', 'abbreviation', 'status', 'progAdminUsers', 'ownerRepUsers', 'projectManagerUsers'],
            canEdit: false,
            canDelete: false,
        }
    },
    methods: {
        deleteAgency: function (item) {
            if (this.canDelete) {
                this.$bvModal.msgBoxConfirm('Would you like to delete this agency? This action cannot be undone.')
                    .then(async (value) => {
                        if (value) {
                            this.$api.deleteItem(this, 'agency', this.agencyInfo)
                            this.$toasted.info('Agency deleted')
                            this.$router.push('/agency/list')
                        } else {
                            this.$toasted.error('Unable to delete agency')
                        }
                    })
            } else {
                this.$toasted.error(`Unable to delete agency since it references projects and/or users`)
            }
        }
    },
    created () {
        this.$api.getItem(this, 'agency', this.agencyId,
            ['progAdminUsers', 'ownerRepUsers', 'projectManagerUsers'])
            .then((data) => {
                this.title = data['name']
                this.agencyInfo = data
            })
        Authorization.can({ action: 'edit', model: 'agency', arg: this.agencyId })
            .then((can) => this.canEdit = can)
        Authorization.can({ action: 'delete', model: 'agency', arg: this.agencyId })
            .then((can) => this.canDelete = can)
    },
})
</script>
